// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"016ca371","900":"a2db4454"}[chunkId] + ".chunk.js";
};